(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ado-collection-split"] && !Shopify.designMode) return;
  try {
    
  if (!window.__adoCollectionSplitViewAllBound) {
    window.__adoCollectionSplitViewAllBound = true;

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-ado-view-all]');
      if (!button) return;

      const section = button.closest('.ado-split-collection');
      if (!section) return;

      section.querySelectorAll('[data-ado-remaining-product][hidden]').forEach((item) => {
        item.hidden = false;
      });

      button.setAttribute('aria-expanded', 'true');
      const cta = button.closest('.ado-split-collection__cta');
      if (cta) cta.hidden = true;
    });
  }

  } catch(e) { console.error(e); }
})();
})();
